export const MESSAGES = [
	'Accomplishing',
	'Actioning',
	'Actualizing',
	'Baking',
	'Brewing',
	'Calculating',
	'Cerebrating',
	'Churning',
	'Clauding',
	'Coalescing',
	'Cogitating',
	'Computing',
	'Conjuring',
	'Considering',
	'Cooking',
	'Crafting',
	'Creating',
	'Crunching',
	'Deliberating',
	'Determining',
	'Doing',
	'Effecting',
	'Finagling',
	'Forging',
	'Forming',
	'Generating',
	'Hatching',
	'Herding',
	'Honking',
	'Hustling',
	'Ideating',
	'Inferring',
	'Manifesting',
	'Marinating',
	'Moseying',
	'Mulling',
	'Mustering',
	'Musing',
	'Noodling',
	'Percolating',
	'Pondering',
	'Processing',
	'Puttering',
	'Reticulating',
	'Ruminating',
	'Schlepping',
	'Shucking',
	'Simmering',
	'Smooshing',
	'Spinning',
	'Stewing',
	'Synthesizing',
	'Thinking',
	'Transmuting',
	'Vibing',
	'Working',
];
